import { z } from 'zod';

export const BaseInferenceOptionsSchema = z.object({
  model: z.string(),
  temperature: z.number().min(0).max(2).optional(),
  max_tokens: z.number().optional(),
  top_p: z.number().min(0).max(1).optional(),
  top_k: z.number().min(1).max(100).optional(),
  n: z.number().min(1).max(10).optional(),
  stream: z.boolean().optional(),
  presence_penalty: z.number().min(-2).max(2).optional(),
  frequency_penalty: z.number().min(-2).max(2).optional(),
  logprobs: z.number().min(0).max(5).optional(),
  stop: z.array(z.string()).optional(),
  context_length_exceeded_behavior: z.enum(['truncate', 'error']).optional(),
});

export const ChatMessageSchema = z.object({
  role: z.enum(['system', 'user', 'assistant', 'tool', 'function']),
  content: z.union([
    z.string(),
    z.array(
      z.object({
        type: z.enum(['text', 'image']),
        text: z.string().optional(),
        image_url: z
          .object({
            url: z.string(),
          })
          .optional(),
      }),
    ),
  ]),
  name: z.string().optional(),

  // TODO these are cruft from the old UI, and should be removed/moved
  id: z.string().optional(),
  tool_calls: z.any().optional(),
  tool_call_id: z.string().optional(),
  metadata: z.any().optional(),
});
export type ChatMessageSchema = z.infer<typeof ChatMessageSchema>;

export const ChatInferenceRequestSchema = BaseInferenceOptionsSchema.extend({
  messages: z.array(ChatMessageSchema),

  tools: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        description: z.string(),
        schema: z.object({
          type: z.enum(['object']),
          properties: z.record(z.string(), z.any()),
        }),
      }),
    )
    .optional(),
  // TODO this needs the model to be passed in to a function to set the max to the correct number (the models max tokens)
  //   prompt_truncate_len: z.number().min(1).max(4096).default(1500).optional(),
}).superRefine(({ temperature, top_p }, ctx) => {
  if (temperature !== undefined && top_p !== undefined) {
    ctx.addIssue({
      code: 'custom',
      message: "Either 'temperature' or 'top_p' can be provided, but not both",
      path: ['temperature', 'top_p'], // Note: This path is illustrative; Zod does not support multiple paths in addIssue.
    });
  }
});
export type ChatInferenceRequest = z.infer<typeof ChatInferenceRequestSchema>;

export const CompletionInferenceRequestSchema = BaseInferenceOptionsSchema.extend({
  prompt: z.string(),
  echo: z.boolean().optional(),
}).superRefine(({ temperature, top_p }, ctx) => {
  if (temperature !== undefined && top_p !== undefined) {
    ctx.addIssue({
      code: 'custom',
      message: "Either 'temperature' or 'top_p' can be provided, but not both",
      path: ['temperature', 'top_p'], // Note: This path is illustrative; Zod does not support multiple paths in addIssue.
    });
  }
});
export type CompletionInferenceRequest = z.infer<typeof CompletionInferenceRequestSchema>;
